export default (BSEURL) => {
  return {
    // 登陆
    login: BSEURL + '/sign/login'
  }
}



// WEBPACK FOOTER //
// ./src/api_b2c/home.js